
import React from 'react';
import { GraduationCap } from 'lucide-react';

interface EducationData {
  degree: string | null;
  field_of_study: string | null;
  institution: string;
}

interface EducationSectionProps {
  education: EducationData[] | null;
}

const EducationSection: React.FC<EducationSectionProps> = ({ education }) => {
  return (
    <div className="flex items-start gap-4">
      <div className="bg-[#0EA5E9]/10 p-2 rounded-full">
        <GraduationCap className="h-5 w-5 text-[#0EA5E9]" />
      </div>
      <div>
        <h3 className="text-sm font-medium text-gray-800">Latest Education</h3>
        {education && education.length > 0 ? (
          <p className="text-sm text-gray-600">
            {education[0].degree} in {education[0].field_of_study} at {education[0].institution}
          </p>
        ) : (
          <p className="text-sm text-gray-600">No education added</p>
        )}
      </div>
    </div>
  );
};

export default EducationSection;
